import './App.css';
import {Homepage} from "./components/Homepage";
import {APIDataProvider} from "./context/provider/APIDataProvider";

function App() {
  return (
      <APIDataProvider >
        <Homepage />
      </APIDataProvider>
  );
}

export default App;
